import { api } from '@/api'

export type ChartsDetectorStatisticsData = {
  deviceId: number
  startDate: string
  endDate: string
  totalVehicleCount: number
  passengerVehicleCount: number
  truckVehicleCount: number
  unrecognizedVehicleCount: number
  sameDirectionDetections: number
  oppositeDirectionDetections: number
  sameDirectionOccupancyTime: number
  oppositeDirectionOccupancyTime: number
  sameDirectionFlowDensity: number
  oppositeDirectionFlowDensity: number
  sameDirectionCongestionFrequency: number
  oppositeDirectionCongestionFrequency: number
  sameDirectionAverageSpeed: number
  sameDirectionMinSpeed: number
  sameDirectionMaxSpeed: number
  oppositeDirectionAverageSpeed: number
  oppositeDirectionMinSpeed: number
  oppositeDirectionMaxSpeed: number
}

export type ChartsDetectorStatisticsRes = {
  success: boolean
  data: ChartsDetectorStatisticsData
}

const chartsDetectorService = api.injectEndpoints({
  endpoints: (build) => ({
    getChartsDetectorStatistics: build.query<
      ChartsDetectorStatisticsRes,
      { deviceId: number; startDate: string; endDate: string }
    >({
      query: ({ deviceId, startDate, endDate }) => ({
        url: '/devices/statistics',
        method: 'GET',
        params: {
          deviceId,
          startDate,
          endDate,
        },
      }),
    }),
  }),
  overrideExisting: false,
})

export const { useGetChartsDetectorStatisticsQuery } = chartsDetectorService
